<template>
    <div class="container-fluid">
        <div class="container is-fluid">

            <div class="columns">
                <div class="column has-text-centered"></div>
                <div class="column has-text-centered">
                    <h1 class="title">Transaction</h1>
                </div>
                <div class="column">
                    <div class="add-transaction dropdown is-hoverable mb-15 is-pulled-right">
                        <div class="dropdown-trigger">
                            <button class="button is-success" aria-haspopup="true" aria-controls="dropdown-menu" @click="">
                                <span>Add Transaction</span>
                                <span class="icon is-small">
                                <i class="fas fa-angle-down" aria-hidden="true"></i>
                            </span>
                            </button>
                        </div>
                        <div class="dropdown-menu" id="dropdown-menu" role="menu">
                            <div class="dropdown-content">
                                <router-link
                                        tag="a"
                                        to="/banking/create"
                                        class="dropdown-item">
                                    <span>Money In</span>
                                </router-link>
                                <router-link
                                        tag="a"
                                        to="/banking/create-refund"
                                        class="dropdown-item">
                                    <span>Money Out</span>
                                </router-link>

                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="columns">
                <div class="column">

                    <div class="transaction-row field-row">
                        <div class="field transaction-field">
                            <p class="control search-field is-expanded has-icons-left is-fullwidth">
                                <input class="input" type="text" v-model="search" v-on:keyup="searchFormChange"
                                       placeholder="Search Transactions">
                                <span class="icon is-small is-left">
                      <i class="fas fa-search"></i>
                    </span>
                            </p>
                        </div>
                        <div class="field transaction-date">
                            <p class="control is-expanded has-icons-left is-fullwidth">
                                <datetime
                                        input-class="input"
                                        v-model="transaction_from"
                                        @change="filter"
                                        :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                        type="date"
                                        value-zone="local"
                                        zone="local"
                                        placeholder="Select date from"
                                ></datetime>
                                <span class="icon is-small is-left">
                      <i class="fas fa-calendar-alt"></i>
                    </span>
                            </p>
                        </div>
                        <div class="field transaction-date">
                            <p class="control is-expanded has-icons-left is-fullwidth">
                                <datetime
                                        input-class="input"
                                        v-model="transaction_to"
                                        @change="filter"
                                        :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                        type="date"
                                        value-zone="local"
                                        zone="local"
                                        placeholder="Select date to"
                                ></datetime>
                                <span class="icon is-small is-left">
                      <i class="fas fa-calendar-alt"></i>
                    </span>
                            </p>
                        </div>

                        <div class="field client-field">
                            <div class="control">
                                <model-select :options="options"
                                              v-model="user"
                                              class="input"
                                              placeholder="Select Client">
                                </model-select>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <app-loader :loading="false" :color="options.color" :size="options.size"></app-loader>
            <div class="columns" v-if="transactionTotals">
                <div class="theme-table-container table-container center-column w-100">
                    <table class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped">
                        <tr>
                            <th class="cursor-pointer" @click="openClientDeposit">Client Deposit</th>
                            <td class="cursor-pointer" @click="openClientDeposit">{{ getCurrency }}{{ transactionTotals.deposit | formatNumber }}
                                <span class="icon">
                                   <i class="fas fa-eye"></i>
                                </span>
                            </td>
                            <th>Amount received</th>
                            <td>{{ getCurrency }}{{ transactionTotals.amount_received | formatNumber }}</td>
                            <th>Amount used for payments</th>
                            <td>{{ getCurrency }}{{ transactionTotals.amount_used | formatNumber }}</td>
                            <th class="cursor-pointer" @click="openReceivables">Receivables</th>
                            <td class="cursor-pointer" @click="openReceivables">{{ getCurrency }}{{ transactionTotals.receivables | formatNumber }}
                                <span class="icon">
                                   <i class="fas fa-eye"></i>
                                </span>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="columns center" v-if="!getLoaderStatus">
                <div class="theme-table-container table-container center-column w-100">
                    <table class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped">
                        <thead>
                        <tr>
                            <th><span @click="setOrder('id')" class="link">ID</span></th>
                            <th><span @click="setOrder('transaction_date')" class="link">Date</span></th>
                            <th><span @click="setOrder('client')" class="link">Client</span></th>
                            <th><span @click="setOrder('type')" class="link">Type</span></th>
                            <th><span @click="setOrder('amount')" class="link">Amount</span></th>
                            <th><span @click="setOrder('payment')" class="link">Payment</span></th>
                            <th><span @click="setOrder('deposit')" class="link">Deposit</span></th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <transaction-table-row></transaction-table-row>
                    </table>
                </div>
            </div>
            <div class="columns" v-if="hasTransactions">
                <div class="column has-text-centered">
                    <nav class="pagination is-centered" role="navigation" aria-label="pagination">
                        <ul class="pagination-list">
                            <li><a class="pagination-link" v-if="getCurrentPage > 2" @click="changePage(getFirstPage)">{{
                                getFirstPage }}</a></li>
                            <li><span class="pagination-ellipsis" v-if="getCurrentPage > 2">&hellip;</span></li>
                            <li><a class="pagination-link" v-if="getCurrentPage > 1"
                                   @click="changePage(getCurrentPage - 1)">{{ getCurrentPage - 1 }}</a></li>
                            <li><a class="pagination-link is-current" @click="changePage(getCurrentPage)">{{
                                getCurrentPage }}</a></li>
                            <li><a class="pagination-link" v-if="getCurrentPage < getLastPage"
                                   @click="changePage(getCurrentPage + 1)">{{ getCurrentPage + 1 }}</a></li>
                            <li><span class="pagination-ellipsis"
                                      v-if="getCurrentPage + 1 < getLastPage">&hellip;</span></li>
                            <li><a class="pagination-link" @click="changePage(getLastPage)"
                                   v-if="getCurrentPage + 1 < getLastPage">{{ getLastPage }}</a></li>
                        </ul>
                    </nav>
                </div>
            </div>
            <client-deposit-history-modal :username="username"></client-deposit-history-modal>
            <receivalbes-modal :username="username"></receivalbes-modal>
        </div>
    </div>
</template>

<script>

    import appLoader from 'vue-spinner/src/ClipLoader'
    import TransactionTableRow from "./TransactionTableRow";
    import {Datetime} from 'vue-datetime'
    import 'vue-datetime/dist/vue-datetime.css'
    import {ModelSelect} from 'vue-search-select'
    import apiUsers from './../../api/apiUsers'
    import ClientDepositHistoryModal from "./ClientDepositHistoryModal";
    import ReceivalbesModal from "./ReceivalbesModal";

    export default {
        components: {
            ReceivalbesModal,
            ClientDepositHistoryModal,
            TransactionTableRow,
            appLoader,
            Datetime,
            ModelSelect
        },
        data() {
            return {
                options: [],
                addTransactionModal: false,
                search: '',
                client: '',
                dateFrom: '',
                dateTo: '',
                order: 1,
                username: '',
                allUsers: []
            }
        },
        computed: {
            hasTransactions() {
                return this.$store.getters.getAllTransactions.length > 0 ? true : false;
            },
            getCurrentPage() {
                return parseInt(this.$store.getters.getTransactionCurrentPage)
            },
            getLoaderStatus() {
                return this.$store.getters.getLoaderStatus
            },
            transaction_from: {
                get() {
                    return this.dateFrom;
                },
                set(value) {
                    this.dateFrom = value;
                    this.filter();
                }
            },
            transaction_to: {
                get() {
                    return this.dateTo;
                },
                set(value) {
                    this.dateTo = value;
                    this.filter();
                }
            },
            user: {
                get() {
                    return this.client;
                },
                set(value) {
                    this.allUsers.forEach((element) => {
                        if(value == element.id){
                            this.username = element.name;
                        }
                    })
                    this.client = value;
                    this.$store.dispatch('getTransactionTotals', value)
                    this.filter();
                }
            },
            transactionTotals() {
                return this.$store.getters.getTransactionTotals;
            },
            getFirstPage() {
                return this.$store.getters.getTransactionFirstPage
            },
            getLastPage() {
                return this.$store.getters.getTransactionLastPage
            },
            getCurrency(){
                return this.transactionTotals.currency == 1 ? '¥' : '$'
            }
        },
        methods: {
            setOrder(orderBy) {
                this.order = this.order == '1' ? 0 : 1;
                this.$store.commit('setOrderByTransactions', {orderBy: orderBy, order: this.order})
                this.$store.dispatch('getTransactionsAction');
            },
            filter() {
                this.$store.commit('setFilterTransactions', {
                    client: this.client,
                    search: this.search,
                    dateFrom: this.dateFrom,
                    dateTo: this.dateTo
                })
                this.$store.dispatch('getTransactionsAction');
            },
            searchFormChange() {
                this.filter();
            },
            addTransaction() {
                this.addTransactionModal = true;
            },
            setSelectOptions(users) {
                let list = []

                users.forEach(function (element) {
                    list.push({
                        value: element.id,
                        text: element.name
                    })
                })

                this.options = list
            },
            changePage(page) {
                this.$router.push({path: '/banking', query: {page: page}})
            },
            openClientDeposit(){
                this.$store.commit('setClientDepositModalStatus', true)
                this.$store.dispatch('fetchClientDeposits', this.user)
            },
            openReceivables(){
                this.$store.commit('setReceivablesModalStatus', true)
                this.$store.dispatch('fetchReceivables', this.user)
            }
        },
        created() {
            this.$store.commit('setTransactionTotals', '')
            apiUsers
                .requestAllUsers()
                .then((response) => {
                    this.allUsers = response.data
                    this.setSelectOptions(response.data)
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        watch: {
            '$route'(to, from) {
                this.$store.commit('setTransactionCurrentPage', to.query.page)
                this.$store.dispatch('getTransactionsAction')
            }
        }
    }
</script>
<style scoped>
    .container {
        margin-top: 25px;
    }

    .field-row {
        display: flex;
    }

    .field-row .field {
        margin-right: 10px;
    }

    .field.transaction-field, .field.client-field {
        flex: 1 1 33%;
    }

    .field.transaction-field {
        flex: 1 1 33%;
    }

    .ui.selection.dropdown {
        min-height: unset;
        padding-top: 9px;
    }

    span.link {
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/Banking/TransactionsTable.vue